export default "__VITE_ASSET__C4RZVNgj__"